import { useState } from "react";
import SectionHeader from "@/components/feature/SectionHeader";

export const homeFaqs = [
  {
    q: "《健身教练》漫画可以免费阅读吗？",
    a: "可以。《健身教练》漫画在43423漫画网提供全集免费在线阅读，无需付费、无需注册即可观看全部章节，还有高清画质可选。",
  },
  {
    q: "《健身教练》漫画一共有多少话？",
    a: "《健身教练》漫画已完结，全本共358话，剧情完整结局圆满，支持从第1话到完结话无缝追读。",
  },
  {
    q: "在43423漫画网阅读需要下载App吗？",
    a: "不需要。网站支持浏览器直接在线阅读，手机、平板、电脑均可访问，打开网页就能看。",
  },
  {
    q: "漫画多久更新一次？",
    a: "连载中的漫画作品每日持续更新，更新完成后会第一时间展示在首页“最新更新”板块，方便读者追更。",
  },
  {
    q: "阅读时遇到图片加载失败怎么办？",
    a: "可以尝试刷新页面或切换网络环境；如问题依然存在，欢迎通过“关于我们”页面中的联系方式向我们反馈，我们会尽快处理。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <SectionHeader
          title="常见问题"
          subtitle="关于阅读与更新，你想知道的都在这里"
          align="center"
        />
        <div className="flex flex-col gap-3">
          {homeFaqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left md:px-5"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-2.5 text-sm font-bold text-foreground-950">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-black text-primary-600">
                      Q
                    </span>
                    {item.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                      open ? "rotate-180 text-primary-500" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="flex items-start gap-2.5 border-t border-background-200/60 px-4 py-3.5 text-xs leading-relaxed text-foreground-600 md:px-5 md:text-sm">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-black text-accent-700">
                        A
                      </span>
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}